<template>
  <v-app-bar
    app
    dark
    color="secondary"
    clipped-left
    height="56"
  >
    <v-app-bar-nav-icon
      v-if="showMenu"
      @click="toggleSidebar"
    />
    <AkvelonLogo />
    <v-spacer />
    <v-row justify="end">
      <UserMenu />
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AkvelonLogo from './AkvelonLogo.vue';
import UserMenu from './UserMenu.vue';

export default {
  components: {
    AkvelonLogo,
    UserMenu,
  },
  computed: {
    ...mapGetters('layout/menu', ['showMenu']),
  },
  methods: {
    ...mapActions('shared/common', ['toggleSidebar']),
  },
};
</script>
